"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var DoneRounded_1 = __importDefault(require("@material-ui/icons/DoneRounded"));
var RotateLeft_1 = __importDefault(require("@material-ui/icons/RotateLeft"));
var RotateRight_1 = __importDefault(require("@material-ui/icons/RotateRight"));
var react_1 = __importStar(require("react"));
var elements_1 = require("../elements");
var layout_1 = require("../layout");
var react_cropper_1 = __importDefault(require("react-cropper"));
require("cropperjs/dist/cropper.css");
var react_virtualized_1 = require("react-virtualized");
function ImageCropDialog(_a) {
    var _this = this;
    var base64 = _a.base64, deferred = _a.deferred;
    var cropperRef = react_1.useRef(null);
    function rotateAndScale(rotation) {
        var _a;
        var cropper = (_a = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current) === null || _a === void 0 ? void 0 : _a.cropper;
        if (cropper) {
            var _b = cropper.getCanvasData(), canvasHeight = _b.height, canvasWidth = _b.width;
            var _c = cropper.getContainerData(), containerHeight = _c.height, containerWidth = _c.width;
            var scaleFactor = 1;
            if (canvasWidth < canvasHeight) {
                scaleFactor = containerWidth / canvasHeight;
            }
            else {
                scaleFactor = containerHeight / canvasWidth;
            }
            cropper.rotate(rotation);
            // cropper.scale(scaleFactor);
            var _d = cropper.getCanvasData(), canvasHeight = _d.height, canvasWidth = _d.width;
            // cropper.setCanvasData({ height: scaleFactor * canvasWidth, width: scaleFactor * canvasHeight })
            cropper.setCropBoxData({ left: 0, top: 0, height: canvasHeight * 0.9, width: canvasWidth * 0.9 });
        }
    }
    var buttonColor = "white";
    return (react_1.default.createElement(elements_1.APDialogCard, { title: "", style: { minWidth: "300px", height: "100%", backgroundColor: "rgba(0,0,0,0.7)", borderRadius: 0, padding: 0 }, leading: react_1.default.createElement(IconButton_1.default, { onClick: function () { return deferred.reject(new Error("USER_CANCELLED")); } },
            react_1.default.createElement(Close_1.default, { htmlColor: buttonColor })), trailing: react_1.default.createElement(layout_1.APRow, { gap: "12px", mainAxisAlignment: "center" },
            react_1.default.createElement(IconButton_1.default, { onClick: function () { return rotateAndScale(-90); } },
                react_1.default.createElement(RotateLeft_1.default, { htmlColor: buttonColor })),
            react_1.default.createElement(IconButton_1.default, { onClick: function () { return rotateAndScale(90); } },
                react_1.default.createElement(RotateRight_1.default, { htmlColor: buttonColor })),
            react_1.default.createElement(IconButton_1.default, { onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    var imageElement, cropper;
                    return __generator(this, function (_a) {
                        imageElement = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current;
                        cropper = imageElement === null || imageElement === void 0 ? void 0 : imageElement.cropper;
                        if (cropper != null) {
                            deferred.resolve(cropper.getCroppedCanvas({ maxHeight: 1080, maxWidth: 1080 }).toDataURL());
                        }
                        return [2 /*return*/];
                    });
                }); } },
                react_1.default.createElement(DoneRounded_1.default, { htmlColor: buttonColor }))) },
        react_1.default.createElement(layout_1.APColumn, { mainAxisSize: "max", crossAxisAlignment: "stretch" },
            react_1.default.createElement(layout_1.APSizedBox, { height: "12px" }),
            react_1.default.createElement(layout_1.APExpanded, { noClone: true },
                react_1.default.createElement(react_virtualized_1.AutoSizer, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    if (height == 0) {
                        return null;
                    }
                    return react_1.default.createElement(react_cropper_1.default, { ref: cropperRef, src: base64, minContainerHeight: height, minContainerWidth: width, style: { maxWidth: "100%", maxHeight: "90vh" }, viewMode: 2, dragMode: "none" });
                })),
            react_1.default.createElement(layout_1.APSizedBox, { height: "12px" }))));
}
exports.default = ImageCropDialog;
